import React from 'react';
import PageTemplate from '../components/Layout/PageTemplate/PageTemplate';
import CommonList from '../views/CommonTableView';
const AuditDocumentRegisterPage = () => {
    return (
        <PageTemplate>
 <CommonList page={"audit_document_register"}/>
        </PageTemplate>
    );
};

export default AuditDocumentRegisterPage;

